import {Brick, registerBrick} from 'olympe';

export default class AddFilter extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} body
     * @param {string} field
     * @param {string} value
     * @param {boolean} parseValue
     * @param {string} operator
     * @param {*} group
     * @param {function()} forwardEvent
     * @param {function(string)} setBody
     */
    update ($, [body, field, value, parseValue, operator, group], [forwardEvent, setBody]) {
        let objectBody = {};
        if (body !== '{}' && Boolean(body)) {
            // body contains some data
            objectBody = JSON.parse(body);
        }
        let groupValue = Number(group);


        if (typeof group === 'string') {
            groupValue = group.split(',').map(s => Number(s));
        }
        let filtersArray = [];
        if (objectBody.filters) {
            filtersArray = objectBody.filters;
        }

        filtersArray.push({
            field: field,
            value: parseValue ? JSON.parse(value) : value,
            ... (Boolean(operator) && {operator: operator}),
            ... ((typeof groupValue === 'number'|| Array.isArray(groupValue)) && {group: groupValue})
        });
        objectBody.filters = filtersArray;
        setBody(JSON.stringify(objectBody));
        forwardEvent();
    }
}

registerBrick('018a029d56a4606481ef', AddFilter);
